import { useEffect, useRef } from 'react';

import { useAgGridClientTableContext } from 'core/states';

interface IProps {
  heldRowId: string | null;
}

// Once, a latch: re-selecting on every data change would fight the user's click.
export const PreselectHeldAgreement = ({ heldRowId }: IProps) => {
  const hasPreselectedRef = useRef(false);

  const { gridApi, rows } = useAgGridClientTableContext();

  useEffect(() => {
    if (hasPreselectedRef.current || !gridApi || !rows?.length || !heldRowId) {
      return;
    }

    // The provider fills `rows` before the grid holds the nodes, so the node may be missing.
    const heldNode = gridApi.getRowNode(heldRowId);

    if (!heldNode) {
      return;
    }

    hasPreselectedRef.current = true;
    heldNode.setSelected(true);
  }, [gridApi, heldRowId, rows]);

  return null;
};
